import React from "react";

export class TABLE extends React.Component {
    rawMarkup() {
        var rawMarkup = this.props.content
        return { __html: rawMarkup };
    }
    render() {
        return (
            <div style={{ width: "100%" }}>
                <table class="styled-table" dangerouslySetInnerHTML={this.rawMarkup()}>
                </table></div>
        )
    }
}